/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { RevokeRequestBuilderRequestsMetadata, type RevokeRequestBuilder } from './revoke/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /contracts/{contract-id}/mandate/signing
 */
export interface SigningRequestBuilder extends BaseRequestBuilder<SigningRequestBuilder> {
    /**
     * The revoke property
     */
    get revoke(): RevokeRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const SigningRequestBuilderUriTemplate = "{+baseurl}/contracts/{contract%2Did}/mandate/signing";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const SigningRequestBuilderNavigationMetadata: Record<Exclude<keyof SigningRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    revoke: {
        requestsMetadata: RevokeRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
